class DropdownView extends ViewBasic {
	constructor(options) {
		super(options);

		//set default variables
	}

	init() {
		this.addEvents();
	}

	addEvents() {
		this.$('.dropBtn').on('click', e => this.clickHandler(e));
	}

	removeEvents() {

	}

	clickHandler(e){
		$(e.currentTarget).closest('.dropdown').toggleClass('active');
	}
}